import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
const ProjectButton = ({
    title,
    subtitle,
    projectPath,
    delay,
    hoverPreview,
    onHoverStart,
    onHoverEnd,
}) => {
    const [isActive, setIsActive] = useState(false);
    const navigate = useNavigate();

    const containerStyle = {
        display: 'flex',
        flexDirection: 'column',
        gap: '2px',
        padding: '12px 16px 10px',
        border: 'none',
        cursor: 'pointer',
        textAlign: 'left',
        font: 'inherit',
        transition: 'background-color 0.2s ease',
        borderRadius: '10px',
        WebkitTapHighlightColor: 'transparent',
    };

    const handleClick = () => {
        navigate(projectPath);
    };

    const handleMouseEnter = () => {
        setIsActive(true);
        if (onHoverStart && hoverPreview) {
            onHoverStart(hoverPreview);
        }
    };

    const handleMouseLeave = () => {
        setIsActive(false);
        if (onHoverEnd) {
            onHoverEnd();
        }
    };

    return (
        <button
            type="button"
            aria-label={`${title}: ${subtitle}`}
            className={`fade-in-section project-button delay-${delay}${isActive ? ' project-button--active' : ''}`}
            style={containerStyle}
            onClick={handleClick}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            onFocus={handleMouseEnter}
            onBlur={handleMouseLeave}
            onTouchStart={handleMouseEnter}
            onTouchEnd={handleMouseLeave}
            onTouchCancel={handleMouseLeave}
        >
            <div className="text-body">{title}</div>
            <div className="text-body-sm">{subtitle}</div>
        </button>
    );
};

export default ProjectButton;
